import React from 'react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import { CardsRow, Row } from '@contently/toolkit';

import AggregateEventCard from './aggregate_event_card';

const AggregateCardsWrapper = styled(CardsRow)`
  @media screen and (max-width: 800px) {
    flex-wrap: wrap;
    > div[class*='CardContainer'] {
      flex: auto;
      flex-basis: 45%;
      margin: 0 2% 2% 0;
    }
  }
  @media screen and (max-width: 480px) {
    flex-direction: column;
    > div[class*='CardContainer'] {
      margin: 0 0 10px 0;
    }
  }
`

const gradientColors = {
  bgLight: "#c3bad4",
  bgDark: "#ad9fcc"
};

const AggregateEvents = ({ data }) => {
  if (!data) return null;

  return (
    <Row>
      <AggregateCardsWrapper>
        <AggregateEventCard {...gradientColors} title="Total visits" data={data.portal_visited} />
        <AggregateEventCard {...gradientColors}
          title="New content requested"
          data={data.request_new_content_button_clicked}
        />
        <AggregateEventCard {...gradientColors} title="Total links clicked" data={data.link_click} />
        <AggregateEventCard {...gradientColors} title="Total content shares" data={data.copy_url + data.email} />
        <AggregateEventCard {...gradientColors} title="Shared content views" data={data.shared_url_visited} />
      </AggregateCardsWrapper>
    </Row>
  );
};

AggregateEvents.defaultProps = {
  data: null
};

AggregateEvents.propTypes = {
  data: PropTypes.shape({
    portal_visited: PropTypes.number,
    link_click: PropTypes.number,
    copy_url: PropTypes.number,
    shared_url_visited: PropTypes.number,
    request_new_content_button_clicked: PropTypes.number,
    email: PropTypes.number
  })
};

export default AggregateEvents;



// WEBPACK FOOTER //
// ./app/javascript/app/components/content_portals/aggregate_events.jsx